<template>
  <b-modal id="featureAccessModal" centered size="md" close-on-backdrop hide-footer hide-header-close
    @shown="handleModalShown">
    <template #modal-header>
      <div class="feature-access-header">
        <div class="text-center">
          <h4>Feature Access</h4>
        </div>
      </div>
    </template>
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <b-container fluid>
      <div class="feature-access-form">
        <form @submit.prevent="onSubmit">
          <div class="form-group mb-3">
            <label class="form-label">Email:</label>
            <input type="text" class="form-control" :value="email" readonly />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Select Feature:</label>
            <div class="checkbox-group feature-item">
              <div v-for="feature in featureAccessCategories" :key="feature.id" class="custom-checkbox p-2">
                <input type="checkbox" :id="`feature-${feature.id}`" :value="feature.id" v-model="selectedFeatures" />
                <label :for="`feature-${feature.id}`" class="custom-label">
                  {{ feature.name }}
                </label>
                <span v-if="feature.description" v-b-tooltip.hover :title="feature.description">
                  <i class="fas fa-info-circle" style="cursor: pointer; margin-left: 10px; color: #007bff;"></i>
                </span>
              </div>
            </div>
            <p class="text-info mt-4">
              <strong>Note:</strong> By selecting the feature(s), the access will be provided to the rep admin.
            </p>
          </div>
          <div class="form-group text-center mb-3 mt-3">
            <b-button class="univ-btn px-4 py-2" type="submit">
              Apply
            </b-button>
          </div>
        </form>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";

export default {
  name: "FeatureAccessModal",
  props: {
    email: {
      type: String,
      required: true,
    },
    featureAccessCategories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedFeatures: [],
    };
  },
  methods: {
    closeModal() {
      this.reset();
      this.$emit("onCloseModal");
    },
    reset() {
      this.selectedFeatures = [];
      this.$bvModal.hide("featureAccessModal");
    },
    onSubmit() {
      const selectedFeaturesIds = new Set(this.selectedFeatures);
      const payload = {
        rep_admin_email: this.email,
        categories: this.featureAccessCategories.map((feature) => ({
          category_id: feature.id,
          status: selectedFeaturesIds.has(feature.id) ? 1 : 0,
        })),
      };

      console.log("Payload", payload);

      const url = `v2/update-admin-feature`;
      let loader = this.$loading.show();
      Api.post(url, payload)
        .then((res) => {
          this.$notify(res.data.message);
          this.$bvModal.hide("featureAccessModal");
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error");
        })
        .finally(() => {

          loader.hide();

        });


    },
    handleModalShown() {
      console.log("handleModalShown");
      this.updateFeatureAccess();
    },
    updateFeatureAccess() {
      const url = `v2/get-admin-feature-status?email=${encodeURIComponent(this.email)}`;
      let loader = this.$loading.show();

      Api.get(url)
        .then((res) => {
          console.log("Update Feature Access", res);
          const userData = res.data.data; 
          if (userData && userData.categories) {
            this.selectedFeatures = [];
            
            this.featureAccessCategories.forEach(feature => {
              if (userData.categories[feature.name] === true) {
                this.selectedFeatures.push(feature.id);
              }
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching feature status:", err);
          this.$notify(err.response?.data?.message || "Failed to load feature access", "error");
        })
        .finally(() => {
          loader.hide();
        });
    }
  },
};
</script>

<style scoped>
.feature-access-header {
  width: 100%;
  padding-top: 15px;
  margin-bottom: 0;
  padding-bottom: 0;
}

.feature-access-form {
  margin-top: -10px;
}

.feature-list {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.feature-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.feature-item  .custom-checkbox input {
  position: static !important;
  opacity: 1 !important; 
}

.feature-label {
  font-size: 15px;
  cursor: pointer;
  margin-bottom: 0;
}

.btn-container {
  position: absolute;
  top: -100px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.btn-container:hover {
  background: #f8f9fa;
}
</style>
